import { render, staticRenderFns } from "./LicenseExpiryAlerts.vue?vue&type=template&id=508cebc3&scoped=true&"
import script from "./LicenseExpiryAlerts.vue?vue&type=script&lang=js&"
export * from "./LicenseExpiryAlerts.vue?vue&type=script&lang=js&"
import style0 from "./LicenseExpiryAlerts.vue?vue&type=style&index=0&id=508cebc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cebc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
